var $=jQuery;
jQuery(document).ready(function ($) {
  /*** PDD SLIDER ***/
  var product_custom = document.querySelectorAll('.product-slider .product-grid li');
  if (product_custom.length > 4) {
    product_custom.forEach(function(product_item) {
      var product_slider = product_item.closest('.product-slider .product-grid');
      if (product_slider) {
        var flkty = new Flickity(product_slider, {
          pageDots: false,
          cellAlign: 'left',
          fade: true,
          groupCells: true,
          wrapAround: true,
          autoPlay: false,
          prevNextButtons: false,
          freeScroll: true, 
        });
      }
    });
  }
  var product_custom = document.querySelectorAll('.product-slider .product-grid li');
    if (product_custom.length > 4) {
      product_custom.forEach(function(product_item) {
        var product_slider = product_item.closest('.product-slider .product-grid');
        if (product_slider) {
          var flkty = new Flickity(product_slider, {
             pageDots: false,
            cellAlign: 'left',
            groupCells: true,
            wrapAround: true,
            autoPlay: false,
            fade: true,
            prevNextButtons: true,
            freeScroll: true, 
          });
        }
      });
    }

 // var product_custom = document.querySelectorAll('.product-slider .product-grid li');
 //    if (product_custom.length > 1) {
 //      product_custom.forEach(function(product_item) {
 //        var product_slider = product_item.closest('.product-slider .product-grid');
 //        if (product_slider) {
 //          var flkty = new Flickity(product_slider, {
 //             pageDots: false,
 //            cellAlign: 'left',
 //            groupCells: true,
 //            wrapAround: true,
 //            autoPlay: false,
 //            prevNextButtons: true,
 //            freeScroll: true, 
 //          });
 //        }
 //      });
 //    }
 // Get the gallery items
  var $gallery = $('.product-single__gallery');
  var galleryItems = $gallery.find('.product-single__gallery-item').length;
  
  // Only initialize Flickity if there's more than one item
  if (galleryItems > 1) {
    $gallery.flickity({
      imagesLoaded: true,
      groupCells: false,
      dragThreshold: 5,
      cellAlign: 'center',
      wrapAround: false,
      freeScroll: false,
      prevNextButtons: false,
      percentPosition: false,
      pageDots: true,
      rightToLeft: false,
      fade: true,
      autoPlay: false,
      // sync: '.product-single__thumbnails'
    });
  }
  $(".product-single__thumbnails").flickity({
      freeScroll: false,
      wrapAround: true,
      pageDots: false,
      prevNextButtons: false, 
      autoPlay: false,
      cellAlign: 'left',
      asNavFor: '.product-single__gallery'
  });
  $('.product-single__gallery').on('change.flickity', function(event, index) {
      var $thumbnails = $('.product-single__thumbnails li');
      $thumbnails.removeClass('active'); 
      $thumbnails.eq(index).addClass('active'); 
  });
  $('.product-single__thumbnails li').first().addClass('active');

  $('.product-single__thumbnails li').on('click', function() {
      var index = $(this).index();
      $('.product-single__gallery').flickity('select', index);  
  });
  $('.product-single__thumbnails').on('change.flickity', function(event, index) {
        $('.product-single__gallery').flickity('select', index);
  }); 
});